module.exports = __webpack_public_path__ + "img/hr-tank-turret.c6a8563d.png";